import React, { memo } from 'react';
import { View, Image, TouchableOpacity } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Text, Space } from '@redlink/components/atoms';

export const PoweredByLogo = memo(() => {
  const { styles } = useStyle();
  return (
    <TouchableOpacity
      onPress={() => (window.location.href = 'https://redl.ink')}
      style={styles.poweredByContainer}
    >
      <Image
        resizeMode="contain"
        style={styles.poweredByImage}
        source={require('@redlink/assets/images/logo.png')}
      />
      <Space size={8} />
      <View style={styles.poweredByTextContainer}>
        <Text style={styles.poweredBySubtitleText}>Powered by</Text>
        <Text style={styles.poweredByTitleText}>REDlink</Text>
      </View>
    </TouchableOpacity>
  );
});

const useStyle = createUseStyle(({ colors, size }) => ({
  poweredByContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row-reverse',
  },
  poweredByImage: {
    width: 30,
    height: 30,
  },
  poweredBySubtitleText: {
    color: colors.subtitle,
    fontSize: 10,
  },
  poweredByTitleText: {
    color: colors.title,
    fontSize: 14,
    fontWeight: 'bold',
  },
  poweredByTextContainer: {
    marginTop: 5,
  },
}));
